<large-card [largeCardInteriorOptions]="largeCardInteriorOptions"></large-card>
